<wl-user-selector noneText="{{ 'common.select' | translate | titlecase }}" [(ngModel)]="selectedUserId"></wl-user-selector>
